$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function l(data) {
    console.log(data);
}

window.Ladda = require('ladda');

S = {
    ajax: function (url, data, successFun, finallyFun) {
        $.post({
            url: SYS.pathApp + url,
            data: data,
            success: function (response) {
                try {
                    if (!response) {
                        throw 'Empty response!';
                    }

                    if (typeof response !== 'object') {
                        try {
                            response = JSON.parse(response);
                        }
                        catch (e) {
                            throw 'Error JSON! Response: [' + response + ']';
                        }
                    }

                    if (response.response.error) {
                        switch (response.response.error.code) {
                            case 404:
                                throw 'Error! Code: 404';

                            default:
                                break;
                        }
                    }

                    successFun(response.response);
                }
                catch (e) {
                    S.log(e);
                }
                finally {
                    finallyFun();
                }
            },

            error: function (response) {
                S.log('Error response! Response: [' + response + ']');

                finallyFun();
            }
        });
    },

    val: function (element) {
        return $.trim($(element).val());
    },

    validator: function (data) {
        var messages = [];

        for (var i = 0; i < data.length; i++) {
            if (!data[i][0]) {
                messages.push(data[i][1]);
            }
        }

        return messages;
    },

    messagesJoin: function (messages) {
        var newMessages = [];

        var messagesCount = messages.length;

        for (var i = 0; i < messagesCount; i++) {
            newMessages.push((messagesCount > 1 ? '<b>' + (i + 1) + '.</b> ' : '') + messages[i]);
        }

        return newMessages.join('<br>');
    },

    printMessage: function (element, type, text) {
        switch (type) {
            case 'hide':
                $(element).html('');
                return;

            case 'error':
                text = '\
                    <div class="alert alert-danger" role="alert">\
                        ' + text + '\
                    </div>';
                break;

            case 'success':
                text = '\
                    <div class="alert alert-success" role="alert">\
                        ' + text + '\
                    </div>';
                break;

            default:
                return;
        }

        $(element).html(text);
    },


    location: function (URL, open) {
        if (!URL) {
            URL = location.pathname + location.search;
        }

        if (open) {
            window.open(URL);
        } else {
            location.href = URL;
        }
    },

    createAnimationButton: function (element) {
        return Ladda.create(document.querySelector(element));
    },

    startAnimationButton: function (btn) {
        btn.start();
    },

    stopAnimationButton: function (btn) {
        btn.stop();
    },

    log: function (data) {
        alert(data);
    },

    unknownErrorCode: function (data) {
        throw 'Unknown error! Code: [' + data.error.code + ']';
    },

    unknownSuccessCode: function (data) {
        throw 'Unknown success! Code: [' + data.success.code + ']';
    }
};
